<template>
  <v-container fluid>
    <div id="content">
      
      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="dialog = true" depressed>新しい{{ $route.name }}を作成</v-btn>
      </section>

      <v-card flat>
        <v-card-title>
          <v-row>
            <v-col cols="6" md="3">
              <v-text-field
                v-model="filterKeyword.name"
                label="作業名"
                outlined clearable hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :headers="tableHeaders"
          :items="filterItems"
          :sort-by="['code']"
          :sort-desc="[false]"
          :loading="loading"
          @click:row="onRowClick">
            <template v-slot:item.updatedAt="{ item }">
              {{ getDateTime(item.updatedAt) }}
            </template>
        </v-data-table>
      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="600" id="dialog" class="edit-dialog">
        <v-card flat class="drawer-card">
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</span>
          </v-card-title>
          <v-card-text class="scroll-content">
            <v-form v-model="valid">
              <section class="accordion_inner">
                <v-row no-gutters>
                  <v-col cols="12" class="pa-2">
                    <v-text-field
                      ref="code"
                      label="作業種別コード"
                      v-model="editedItem.code"
                      :rules="[rules.required]"
                      class="required"
                      outlined hide-details="auto">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" class="pa-2">
                    <v-text-field
                      ref="name"
                      label="作業名"
                      v-model="editedItem.name"
                      :rules="[rules.required]"
                      class="required"
                      outlined hide-details="auto">
                    </v-text-field>
                  </v-col>
                </v-row>
              </section>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" text x-large>
              <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
            </v-btn>
            <v-btn color="error" @click.stop="remove" :loading="saving" v-if="editedIndex > -1" text x-large>
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { createWorkType, updateWorkType, deleteWorkType } from '../graphql/mutations'
import { listWorkTypes } from '../graphql/queries'
import { 
  onCreateWorkType, onUpdateWorkType, onDeleteWorkType } from '../graphql/subscriptions'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '作業種別コード', align: 'start', value: 'code' },
        { text: '作業名', align: 'start', value: 'name' },
        { text: '更新日時', align: 'start', value: 'updatedAt' },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      editedIndex: -1,
      editedItem: {},
      filterKeyword: {},
    }
  },
  prop: {},
  mounted: async function() {
    //一覧 query
    await this.getWorkTypes()
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateWorkType)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateWorkType
        this.desserts.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateWorkType)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateWorkType
        this.desserts.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteWorkType)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteWorkType
        this.desserts = this.desserts.filter(origin => origin.id !== row.id)
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    filterItems() {
      const map = []
      for (const item of this.desserts) {
        //現場名
        if (this.filterKeyword.name && item.name.indexOf(this.filterKeyword.name) < 0) continue
        //客先
        if (this.filterKeyword.customer && this.filterKeyword.customer.value != item.customerID) continue
        map.push(item)
      }
      return map
    },
    form() {
      return {
        id: this.editedItem.id || null,
        code: this.editedItem.code || null,
        name: this.editedItem.name || null,
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //初期化
    async init() {

    },
    //行選択
    onRowClick(params) {
      this.editedIndex = this.desserts.findIndex(e => e.id === params.id)
      this.editedItem = Object.assign({}, params)

      delete this.editedItem.updatedAt
      delete this.editedItem.createdAt
      this.dialog = true
    },
    //保存
    async save() {
      try {
        this.saving = true
        const data = this.form

        //編集
        if (data.id) {
          await API.graphql(graphqlOperation(updateWorkType, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.name + '] を更新しました' })
          this.myAlert(data.name + 'を更新しました', 'success')

        //新規
        } else {
          delete data.id
          await API.graphql(graphqlOperation(createWorkType, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.name + '] を追加しました' })
          this.myAlert(data.name + 'を追加しました', 'success')
        }

        this.dialog = false

      } catch (e) {
        //console.log(e)
        this.myAlert(e)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.editedItem.name + 'を削除しますか？')) {
          //削除
          await API.graphql(graphqlOperation(deleteWorkType, {
            input: { id: this.editedItem.id }
          }))
          this.log({ type: this.$route.name, text: '[' + this.editedItem.name + '] を削除しました' })
          this.myAlert(this.editedItem.name + 'を削除しました', 'success')
          this.dialog = false
        }

      } catch (error) {
        this.myAlert(error)
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      //this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f] && !!this.$refs[f].reset) this.$refs[f].reset()
      })
      this.editedItem.id = null
    },
    //作業種別の取得
    async getWorkTypes(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTypes, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listWorkTypes.items) {
        this.desserts.push(data)
      }
      if (query.data.listWorkTypes.nextToken) this.getWorkTypes(query.data.listWorkTypes.nextToken)
    },
  },
}
</script>

<style lang='scss' scoped>

</style>
